// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageUnsupportedContent_content__RGwxt {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #8E8E93;
  display: inline-flex;
  align-items: center;
  padding: 8px;
}

.MessageUnsupportedContent_icon__JKtTH {
  margin-right: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/MessageGroup/Content/MessageUnsupportedContent/MessageUnsupportedContent.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,oBAAA;EACA,mBAAA;EAEA,YAAA;AADF;;AAIA;EACE,iBAAA;AADF","sourcesContent":[".content {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: #8E8E93;\n\n  display: inline-flex;\n  align-items: center;\n\n  padding: 8px;\n}\n\n.icon {\n  margin-right: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `MessageUnsupportedContent_content__RGwxt`,
	"icon": `MessageUnsupportedContent_icon__JKtTH`
};
export default ___CSS_LOADER_EXPORT___;
